import { render, staticRenderFns } from "./AdminInventory.vue?vue&type=template&id=0542ccd6"
import script from "./AdminInventory.vue?vue&type=script&lang=js"
export * from "./AdminInventory.vue?vue&type=script&lang=js"
import style0 from "./AdminInventory.vue?vue&type=style&index=0&id=0542ccd6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports